import React from "react";
import { Image } from 'react-bootstrap';
import { useFormContext } from "react-hook-form";
import config from 'config';
import CheckedRadio from '../../assets/images/checked_radio.svg';
import UncheckedRadio from '../../assets/images/unchecked_radio.svg';
import SkuImport from "./SkuImport";
import LineItemGroups from "./LineItemGroups";
import "./SkuTypeSelector.scss"

const SkuSingleType = ({
  title,
  isSelected,
  setSelected,
}) => {

  return (
    <div
      className="radio-button-container sku-single-type-container"
      onClick={() => {
        if (isSelected) {
          return;
        }
        setSelected();
      }}
    >
      <Image
        src={isSelected ? CheckedRadio : UncheckedRadio}
        className="radio-button"
      />
      <label className="radio-button-label sku-single-type-label">
        {title}
      </label>
    </div>
  )
}


const SkuTypeSelector = ({
  prefix="",
}) => {
  const { watch, setValue } = useFormContext();

  const useAdvancedField = `${prefix}useAdvancedLineItemGroups`;

  const useAdvanced = watch(useAdvancedField) || false;
  const setUseAdvanced = (value) => {
    setValue(useAdvancedField, value, { shouldDirty: true })
  }

  return <>
    <SkuSingleType
      title="Simple - only required the transaction including specific SKUs"
      isSelected={!useAdvanced}
      setSelected={() => setUseAdvanced(false)}
    />
    <label className='tips-message'>
      Select SKUs by importing a list from a CSV file. Ensure that the SKUs are placed in the first column, with one SKU per row in the file. By default, the relationship between the imported SKUs is OR relationship.
    </label>

    {!useAdvanced && <SkuImport prefix={prefix}/>}

    <SkuSingleType
      title="Advanced - select the line item requirement one-by-one with the relationship in between"
      isSelected={!!useAdvanced}
      setSelected={() => setUseAdvanced(true)}
    />
    {!!useAdvanced && (
      <>
        <label className='tips-message'>
          Click <a href={config.advancedLineItemGroupsInstructionsUrl} target="_blank" rel="noopener noreferrer">here</a> for instructions.
        </label>
        <LineItemGroups prefix={prefix} />
      </>
    )}
  </>
}

export default SkuTypeSelector;
